import { Button as CMSButton, Spinner } from '@cmsgov/ds-medicare-gov';
import React, { ComponentProps, PropsWithChildren } from 'react';
import { internalLinkClicked, mfaButtonEngagement, MfaButtonEngagementData } from '../analytics';
import cloneObject from '../functions/cloneObject';

type DSButtonAllProps = ComponentProps<typeof CMSButton>;
type DSButtonProps = Pick<DSButtonAllProps, 'id' | 'size' | 'style' | 'variation' | 'disabled' | 'href' | 'type' | 'onClick'>;
export type ButtonProps = DSButtonProps & {
    /** description of what button does for analytics - should be an href if button navigates to a url */
    analyticsData?: Pick<MfaButtonEngagementData, 'linkUrl' | 'text' | 'parentComponentHeading' | 'parentComponentType' | 'siteSection'>
    isLoading?: boolean
    mfaAnalyticsData?: Pick<MfaButtonEngagementData, 'text' | 'parentComponentHeading' | 'parentComponentType' | 'siteSection'>
    noAnalytics?: boolean
}

const Button = (props: PropsWithChildren<ButtonProps>) => {
    let buttonProps = cloneObject(props) as Partial<ButtonProps>;
    delete buttonProps.onClick;
    delete buttonProps.analyticsData;
    delete buttonProps.isLoading;
    delete buttonProps.mfaAnalyticsData;
    delete buttonProps.noAnalytics;

    const onClickWithAnalytics = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (props.mfaAnalyticsData) {
            const {
                text,
                parentComponentHeading,
                parentComponentType,
            } = props.mfaAnalyticsData;
            let buttonStyle: MfaButtonEngagementData['buttonStyle'] = 'default';
            if (props.variation && props.variation === 'ghost') {
                buttonStyle = 'transparent';
            }
            if (props.type === 'submit') {
                buttonStyle = 'primary';
            }

            const analyticsData: MfaButtonEngagementData = {
                text,
                buttonStyle,
                buttonType: props.type || 'button',
                parentComponentHeading,
                parentComponentType,
                linkUrl: props.href,
                siteSection: props.mfaAnalyticsData.siteSection
            }
            mfaButtonEngagement(analyticsData);
            if (props.onClick) {
                props.onClick(e);
            }
            return;
        }

        if (props.onClick) {
            props.onClick(e);
        }

        if (props.noAnalytics) {
            return;
        }

        if (props.variation === 'ghost') {
            if (props.analyticsData) {
                const {
                    linkUrl,
                    text,
                    parentComponentHeading,
                    parentComponentType,
                    siteSection
                } = props.analyticsData;

                internalLinkClicked({
                    //For now we are keeping the url in form of text so linkText can be used in place of linkUrl
                    linkUrl,
                    linkText: text,
                    parentComponentHeading: parentComponentHeading,
                    parentComponentType: parentComponentType,
                    siteSection: siteSection
                });
            }
        }
    }

    return <>
        <CMSButton
            onClick={onClickWithAnalytics}
            {...buttonProps as DSButtonProps}
        >
            {props.isLoading &&
                <Spinner className="ds-u-margin-right--1"/>
            }
            {props.children}
        </CMSButton>
    </>;
}

export default Button;
